import { React, useState } from "react";
import { useNavigate } from "react-router-dom";

import LogoT2m from "../../assets/img/logo_t2m.png";
import LogoT2mWhite from "../../assets/img/logo_t2m_white.png";

import { AiOutlineTable, AiOutlineIdcard } from "react-icons/ai";
import { TbIcons } from "react-icons/tb";
import { HiOutlineColorSwatch } from "react-icons/hi";
import { FaWpforms } from "react-icons/fa";
import { BsArrowBarRight, BsArrowBarLeft } from "react-icons/bs";
import { CgHome } from "react-icons/cg";
import { MdOutlineExitToApp } from "react-icons/md";
import {
  MdContrast,
  MdOutlineTextDecrease,
  MdOutlineTextIncrease,
} from "react-icons/md";
import { BiUserCircle } from "react-icons/bi";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { SidebarStyle } from "./style.js";
import { SideBarItem } from "../SideBarItem/index.jsx";

function Sidebar({
  logOut,
  windowSize,
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
}) {
  const [sideBarCollapse, setSideBarCollapse] = useState(true);
  const navigate = useNavigate();

  function navigateTo(route) {
    setSideBarCollapse(true);
    window.scrollTo(0, 0);
    navigate(route);
  }

  const handleSidebarCollapse = () => {
    setSideBarCollapse(!sideBarCollapse);
  };

  const UserInfo = () => {
    return (
      <div className="user-container">
        {sideBarCollapse ? (
          <SideBarItem
            index={8}
            smallText={"Perfil"}
            bigText={"Perfil"}
            action={navigateTo}
            value={"/"}
            icon={<BiUserCircle title="Perfil" />}
            sideBarCollapse={sideBarCollapse}
          />
        ) : (
          <>
            <BiUserCircle className="user-icon" size={28} title="Perfil" />
            <div className="user-info">
              {sideBarCollapse ? (
                ""
              ) : (
                <span title="Usuário" className="label-sidebar">
                  Breno M.
                </span>
              )}
              {sideBarCollapse ? (
                ""
              ) : (
                <span
                  id="user-department"
                  className="label-sidebar"
                  title="Departamento Pessoal"
                >
                  Departamento pessoal
                </span>
              )}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <Col className={windowSize >= 992 ? "px-0 col-1" : "px-0 col-0"}>
      <SidebarStyle collapse={sideBarCollapse}>
        <Row>
          <Col className="column-container">
            <div className="logo-area">
              {isDarkMode ? (
                <img
                  src={LogoT2mWhite}
                  alt="T2M"
                  onClick={() => navigateTo("/")}
                />
              ) : (
                <img
                  src={LogoT2m}
                  alt="T2M"
                  onClick={() => navigateTo("/")}
                />
              )}
              {sideBarCollapse ? (
                <div className="system-title">
                  <strong>
                    SPL
                  </strong>
                </div>
              ) : (
                <div className="system-title">
                  Sistema de Padronização de Layouts
                </div>
              )}
            </div>
            <div className="sidebar-nav">
              <SideBarItem
                index={0}
                smallText={"Contraste"}
                bigText={"Alto Contraste"}
                action={HandledarkMode}
                icon={<MdContrast title="Alto Contraste" size={24} />}
                sideBarCollapse={sideBarCollapse}
              />
              <SideBarItem
                index={0}
                smallText={"Aumentar"}
                bigText={"Aumentar Fonte"}
                action={increaseFontSize}
                icon={
                  <MdOutlineTextIncrease title="Aumentar Fonte" size={24} />
                }
                sideBarCollapse={sideBarCollapse}
              />
              <SideBarItem
                index={0}
                smallText={"Diminuir"}
                bigText={"Diminuir Fonte"}
                action={decreaseFontSize}
                icon={
                  <MdOutlineTextDecrease title="Diminuir Fonte" size={24} />
                }
                sideBarCollapse={sideBarCollapse}
              />
            </div>
            <div className="sidebar-nav">
              <SideBarItem
                index={1}
                smallText={sideBarCollapse ? "Expandir" : "Retrair"}
                bigText={sideBarCollapse ? "Expandir" : "Retrair"}
                action={handleSidebarCollapse}
                icon={
                  sideBarCollapse ? (
                    <BsArrowBarRight title="Expandir" size={24} />
                  ) : (
                    <BsArrowBarLeft title="Retrair" size={24} />
                  )
                }
                sideBarCollapse={sideBarCollapse}
              />
            </div>

            <div className="sidebar-nav">
              <SideBarItem
                index={2}
                smallText={"Início"}
                bigText={"Início"}
                action={navigateTo}
                value={"/"}
                icon={<CgHome title="Início" />}
                sideBarCollapse={sideBarCollapse}
              />
              <SideBarItem
                index={3}
                smallText={"Tabela"}
                bigText={"Tabela"}
                action={navigateTo}
                value={"/tabela"}
                icon={<AiOutlineTable title="Tabela" />}
                sideBarCollapse={sideBarCollapse}
              />
              <SideBarItem
                index={4}
                smallText={"Componentes"}
                bigText={"Componentes"}
                action={navigateTo}
                value={"/cards"}
                icon={<AiOutlineIdcard title="Componentes" />}
                sideBarCollapse={sideBarCollapse}
              />

              <SideBarItem
                index={5}
                smallText={"Paleta"}
                bigText={"Paleta de cores"}
                action={navigateTo}
                value={"/paletacores"}
                icon={<HiOutlineColorSwatch title="Paleta de cores" />}
                sideBarCollapse={sideBarCollapse}
              />

              <SideBarItem
                index={6}
                smallText={"Ícones"}
                bigText={"Ícones"}
                action={navigateTo}
                value={"/botoes"}
                icon={<TbIcons title="Icones" />}
                sideBarCollapse={sideBarCollapse}
              />

              <SideBarItem
                index={7}
                smallText={"Formulários"}
                bigText={"Formulários"}
                action={navigateTo}
                value={"/formularios"}
                icon={<FaWpforms title="Formulários" />}
                sideBarCollapse={sideBarCollapse}
              />
            </div>

            <UserInfo />

            <div className="sidebar-nav">
              <SideBarItem
                index={8}
                smallText={"Sair"}
                bigText={"Sair"}
                action={logOut}
                icon={<MdOutlineExitToApp title="Sair" />}
                sideBarCollapse={sideBarCollapse}
              />
            </div>
          </Col>
        </Row>
      </SidebarStyle>
    </Col>
  );
}

export default Sidebar;
